export default {
  styles: {
    global: {
      body: {
        bg: 'white.100',
      },
    },
  },
};
